import { Reveal, SectionHeading } from "./Primitives";
import { RESIDENTIAL_TABS } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export const Residential = () => {
  const scrollToQuote = () =>
    document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="residential" className="bg-[#050505] py-20 md:py-28">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <SectionHeading
            overline="Residential Cleaning"
            title={<>A fresh standard of clean for the <span className="gold-gradient italic">home you love</span></>}
            subtitle="Your home deserves more than a quick clean—it deserves the Perfect Touch. From routine maintenance to deep, detailed cleaning, we tailor every service to your home's unique needs, leaving your space spotless, refreshed, comfortable and beautifully maintained."
          />
        </Reveal>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {RESIDENTIAL_TABS.map((t, i) => (
            <Reveal key={t.key} delay={(i % 2) * 0.08}>
              <article
                id={`${t.key}-cleaning`}
                data-testid={`residential-card-${t.key}`}
                className="group relative h-full overflow-hidden border border-white/5 bg-[#121212] hover-lift hover:border-gold flex flex-col scroll-mt-28"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={t.image}
                    alt={`${t.name} — Perfect Touch residential cleaning`}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-transparent to-transparent" />
                  <span className="absolute top-4 left-4 bg-black/60 backdrop-blur-sm border border-gold/40 text-gold text-[10px] uppercase tracking-[0.18em] px-3 py-1">
                    {t.priceLabel} · {t.price}
                  </span>
                </div>

                <div className="p-7 md:p-8 flex flex-col flex-1">
                  <span className="text-[10px] uppercase tracking-[0.2em] text-gold">{t.name}</span>
                  <h3 className="mt-2 font-display text-2xl text-white leading-tight">{t.headline}</h3>
                  <p className="mt-3 text-sm text-zinc-400 leading-relaxed flex-1">{t.body}</p>
                  {t.discounts && (
                    <div className="mt-4 flex flex-wrap gap-2" data-testid={`residential-discounts-${t.key}`}>
                      {t.discounts.map((d) => (
                        <span
                          key={d.label}
                          className="inline-flex items-center gap-1.5 border border-gold/40 bg-gold/10 px-3 py-1.5 text-xs"
                        >
                          <span className="font-semibold text-gold">{d.label}</span>
                          <span className="text-zinc-300">{d.value}</span>
                        </span>
                      ))}
                    </div>
                  )}
                  {t.tagline && <p className="mt-4 font-display italic text-gold">{t.tagline}</p>}
                  <button
                    data-testid={`residential-cta-${t.key}`}
                    onClick={scrollToQuote}
                    className="group/btn mt-6 inline-flex items-center gap-2 bg-gold text-black font-semibold px-6 py-3.5 hover:bg-[#c5a059] transition-colors duration-300 self-start"
                  >
                    {t.cta}
                    <ArrowUpRight size={17} className="group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform" />
                  </button>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <p className="mt-8 text-xs text-zinc-500 max-w-3xl leading-relaxed">
          Starting prices are provided for guidance. Final pricing depends on property size, number of rooms
          and bathrooms, condition, cleaning frequency, requested services, accessibility and applicable add-ons.
        </p>
      </div>
    </section>
  );
};
